module.exports = __webpack_public_path__ + "static/media/HIPAA_Notice_01-2015.b0419578.pdf";